<template>
    <div class="page-sign-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">客服專區</div>
            <div class="breadcrumb-item">全部快件</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <Input style="width: 120px;" size="small" clearable v-model="form.odd_numbers" @keyup.enter.native="handleSearch()" placeholder="快遞單號"></Input>
                </FormItem>
                <FormItem>
                    <Input style="width: 120px;" size="small" clearable v-model="form.phone" @keyup.enter.native="handleSearch()" placeholder="電話號碼"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Row>
                <Col span="2" class="pagger-left">
                    <div class="pagger-total" style="font-weight:bold;font-size:22px;">批量操作</div>
                </Col>
                <Col span="10" class="pagger-left">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style4" @click="handleEditStatusMuitplete" style="width: 25%;">批量修改訂單狀態</div>
                    </div>
                </Col>
            </Row>

            <br>

            <Table ref="table"
                   size="small"
                   border
                   no-data-text="暫無數據"
                   @on-selection-change="handleSelectionChange"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style4" @click="handleEditStatus(index)">修改訂單狀態</div>
                        <div class="pg-btn style7" @click="handleTransfer(index)">轉店</div>
                        <div class="pg-btn style3" v-if="row.status == '已签收'" @click="handleRefund(index)">退款</div>
                        <div class="pg-btn style1" @click="handleDelete(index)">刪除</div>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="odd_numbers">
                    <div class="avatar-box">
                        <a class="pg-btn" @click="handleViewOrder(index)">{{row.odd_numbers}}</a>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>

        <Modal v-model="isShowModalEditStatus"
               title="修改訂單狀態"
               width="400"
               :footer-hide="true"
               @on-cancel="handleModalCloseEditStatus">
            <div class="modal-cont">
                <Spin fix class="pg-sub-loading" v-if="isSubmitingEditStatus">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>
                <Form>
                    <FormItem>
                        <label class="input-label">快遞單號：</label>
                        <span class="input-label" style="color:blue;line-break: anywhere;">{{form_transfer.odd_numbers}}</span> 
                        <br>
                        <span>節點狀態修改：</span>
                        <RadioGroup v-model="form_transfer.status">
                            <Radio :value="10" label="10">珠海倉庫-待出庫</Radio>
                            <Radio :value="30" label="30">珠海倉庫-已出庫</Radio>
                            <Radio :value="40" label="40">澳門倉庫-已入庫</Radio>
                            <Radio :value="50" label="50">澳門倉庫-已出庫</Radio>
                            <Radio :value="60" label="60">澳門門店-未簽收</Radio>
                            <Radio :value="70" label="70">澳門門店-已簽收</Radio>
                        </RadioGroup>
                        <br>
                        <br>
                        <span>是否抹除支付狀態：</span>
                        <RadioGroup v-model="form_transfer.cancel">
                            <Radio :value="0" label="0">否</Radio>
                            <Radio :value="1" label="1">是</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" style="width:100%" @click="handleConfirmStatus()">修改狀態</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>

        <Modal v-model="isShowModalTransfer"
               title="轉店"
               width="400"
               :footer-hide="true"
               @on-cancel="handleModalCloseTransfer">
            <div class="modal-cont">
                <Spin fix class="pg-sub-loading" v-if="isSubmitingTransfer">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>
                <Form>
                    <FormItem style="align:center;text-align:center;">
                        <span style="font-size:26px;">{{form_transfer.odd_numbers}}</span>
                    </FormItem>

                    <FormItem>
                        <div slot="label" class="form-label">
                            <span>類型</span>
                        </div>
                        <RadioGroup v-model="form.type" @on-change="getPickAddress">
                            <Radio :label="1" :checked="form.type == 1">門店</Radio>
                            <Radio :label="2" :checked="form.type == 2">智能櫃</Radio>
                        </RadioGroup>
                    </FormItem>

                    <FormItem v-if="form.type == 1">
                        <Select size="large" placeholder="請選擇轉店的門店(必填)" v-model="form_transfer.arrive">
                            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                    :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                            </Option>
                        </Select>
                    </FormItem>

                    <FormItem v-if="form.type == 2">
                        <Select size="large" placeholder="請選擇轉店的智能櫃(必填)" v-model="form_transfer.arrive">
                            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                    :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                            </Option>
                        </Select>
                    </FormItem>
                    
                    <FormItem>
                        <Input size="large" type="textarea" v-model="form_transfer.remarks" placeholder="備註(選填)" :autosize="{minRows: 2,maxRows: 5}"></Input>
                    </FormItem>
                    
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" style="width:100%" @click="handleConfirmTransfer()">確定</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>

        <Modal v-model="isShowModalRefund"
               title="退款"
               width="400"
               :footer-hide="true"
               @on-cancel="handleModalCloseRefund">
            <div class="modal-cont">
                <Spin fix class="pg-sub-loading" v-if="isSubmitingRefund">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>
                <Form>
                    <FormItem>
                        <label>快遞單號：{{form_render.odd_numbers}}</label>
                        <br>
                        <label>客戶電話：{{form_render.phone}}</label>
                        <br>
                        <label>提貨櫃點：</label>
                        <Select size="small" v-model="form_render.arrive" disabled style="width:80%;">
                            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress_all"
                                    :key="item.ReceivingID">{{item.ReceivingName}}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem>
                        <label>需要修改的電話號碼：</label>
                        <Input type="number" size="small" v-model="form_transfer.phone" placeholder="請輸入修改的電話號碼" style="width:50%;"></Input>
                        <br>
                        <label>需要修改的提貨櫃點：</label>
                        <Select size="small" placeholder="請選擇提貨櫃點" v-model="form_transfer.arrive" style="width:50%;">
                            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress_all"
                                    :key="item.ReceivingID">{{item.ReceivingName}}
                            </Option>
                        </Select>
                        <br>
                        <span>需要退款：</span>
                        <RadioGroup v-model="form_transfer.type">
                            <Radio :value="0" label="0">否</Radio>
                            <Radio :value="1" label="1">是</Radio>
                        </RadioGroup>
                        <br>
                        <label class="input-label" style="color:red">退款后將不能撤回，請謹慎操作</label>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" style="width:100%" @click="handleConfirmRefund">訂單修改</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>

        <Modal v-model="isShowModalDelete"
               title="刪除"
               width="400"
               :footer-hide="true"
               @on-cancel="handleModalCloseDelete">
            <div class="modal-cont">
                <Spin fix class="pg-sub-loading" v-if="isSubmitingDelete">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>
                <Form>
                    <FormItem>
                        <Input size="large" v-model="form_transfer.odd_numbers" style="width:100%" readonly></Input>
                    </FormItem>
                    <FormItem>
                        <Input size="large" style="width:100%" v-model="form_transfer.code" placeholder="請輸入驗證碼">
                            <Button slot="append" @click="handleVerify">發送驗證碼</Button>
                        </Input>
                    </FormItem>
                    <FormItem>
                        <div class="pg-btn-wrap">
                            <div class="pg-btn style1" style="width:100%" @click="handleConfirmDelete">確認刪除</div>
                        </div>
                    </FormItem>
                </Form>
            </div>
        </Modal>

        <Modal v-model="isShowModalSign_goods"
               title="查詢快件"
               width="1300"
               :footer-hide="true"
               @on-cancel="handleModalSignClose_goods">
            <div class="modal-cont">
               <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
                    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                    <div class="loading-text">Loading</div>
                </Spin>

                <div style="font-weight:bold">快遞信息</div>
                <br>
                <Table no-data-text="" :columns="table1.column" :data="table1.data"></Table>
                <Table no-data-text="" :columns="table1.column1" :data="table1.data1"></Table>
                <Table no-data-text="" :columns="table1.column2" :data="table1.data2"></Table>
                <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
                    <template slot-scope="{row,index}" slot="status">
                        <span v-if="row.status == 0">珠海倉庫-待出庫</span>
                        <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
                        <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
                        <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
                        <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
                    </template>
                </Table>
                <Table no-data-text="" :columns="table1.column4" :data="table1.data4"></Table>
                <Table no-data-text="" :columns="table1.column5" :data="table1.data5"></Table>
                <br><br>
                <div style="font-weight:bold">物流信息</div>
                <br>
                <div class="step-wrap" v-if="detail && detail.length">
                    <div class="step-item clearfix" v-for="(item, index) in detail" :key="item.id">
                        <div class="left">
                            <div class="l-date">
                                <span>{{item.date}}</span>
                                <span>{{item.week}}</span>
                            </div>
                            <div class="l-time">{{item.time}}</div>
                        </div>
                        <div class="right">
                            <div class="r-address">{{item.describe}} , 操作人：{{item.userinfos}}</div>
                        </div>
                    </div>
                </div>

                <div class="data-null" v-else>
                    <div>暫無數據</div>
                </div>
            </div>
        </Modal>

    </div>
</template>

<script>
    import Store from '../../../assets/js/store.js'

    let isthis;
    export default {
        data()
        {
            return {
                pickAddress: [],
                pickAddress_all: [],

                isShowModalRefund: false,
                isSubmitingRefund:false,

                isShowModalEditStatus: false,
                isSubmitingEditStatus: false,

                isShowModalTransfer: false,
                isSubmitingTransfer: false,

                isShowModalDelete: false,
                isSubmitingDelete: false,
                
                isSubmiting: false,

                detail: [],
                isShowModalSign_goods: false,
                isSubmitingLog: false,

                pageIndex: 1, //頁碼
                curPageSize: 10, //一頁數量
                totalCount: 1, //總條數
                pageInput: '', //輸入的頁碼
                form: {
                    arrive: '',
                    odd_numbers: '',
                    phone: '',
                    type: '',
                },
                form_transfer: {
                    odd_numbers: '',
                    phone: '',
                    arrive: '',
                    type: "0",
                    code: '',
                    status: '',
                    cancel: "0",
                    remarks: '',
                },
                form_render: {
                    odd_numbers: '',
                    phone: '',
                    arrive: '',
                    status: '',
                },
                form_goods: [],
                form_order_goods: [],
                activity:'',
                outtimepay:'',
                pay_type: '',
                sums: 0,
                table: {
                    column: [
                        {
                            type: 'selection',
                            width: 60,
                            align: 'center'
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 300
                        },
                        {
                            title: '出貨單號',
                            key: 'odd_numbers',
                            slot: 'odd_numbers',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '物流節點',
                            key: 'status',
                            align: 'center',
                            minWidth: 130,
                            sortable: true
                        },
                        {
                            title: '提貨櫃點',
                            key: 'receivingName',
                            align: 'center',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '付款狀况',
                            key: 'pay_status',
                            align: 'center',
                            minWidth: 130,
                            sortable: true
                        },
                        // {
                        //     title: '用戶名稱',
                        //     key: 'recipient_contacts',
                        //     align: 'center',
                        //     minWidth: 130,
                        //     sortable: true
                        // },
                        {
                            title: '客戶電話',
                            key: 'recipient_phone',
                            align: 'center',
                            minWidth: 130,
                            sortable: true
                        },
                        // {
                        //     title: '支付方式',
                        //     key: 'online_overtime',
                        //     align: 'center',
                        //     minWidth: 150,
                        //     sortable: true
                        // },
                        // {
                        //     title: '合計費用',
                        //     key: 'sum',
                        //     align: 'center',
                        //     minWidth: 100,
                        //     sortable: true,
                        //     className: 'demo-table-info-cell-name-sum'
                        // },
                        {
                            title: '是否同城',
                            key: 'goods_type',
                            align: 'center',
                            minWidth: 150,
                            sortable: true
                        },
                        {
                            title: '更新時間',
                            key: 'created_at',
                            align: 'center',
                            sortable: true,
                            minWidth: 150
                        },
                    ],
                    data: []
                },
                table1: {
                    column: [
                        {
                            title: '快遞單號',
                            key: 'order',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶電話',
                            key: 'phone',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '客戶名稱',
                            key: 'username',
                            align: 'center',
                            minWidth: 80
                        },
                    ],
                    column1: [
                        {
                            title: '重量',
                            key: 'weight',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '尺寸',
                            key: 'size_sum',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '提貨櫃點',
                            key: 'store',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column2: [
                        {
                            title: '快件明細',
                            key: 'detailed',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '異常件',
                            key: 'abnormal',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '出庫袋號',
                            key: 'sack_number',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column3: [
                        {
                            title: '最新貨態',
                            slot: 'status',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '更新時間',
                            key: 'created_time',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '貨架號',
                            key: 'shelves',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column4: [
                        {
                            title: '代收費',
                            key: 'amount',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '附加費',
                            key: 'surcharge_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '到附運費',
                            key: 'freight_collect',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    column5: [
                        {
                            title: '超期費',
                            key: 'outTime_price',
                            align: 'center',
                            minWidth: 100
                        },
                        {
                            title: '合計費用',
                            key: 'total_price',
                            align: 'center',
                            minWidth: 100
                        },
                    ],
                    data: [],
                    data1: [],
                    data2: [],
                    data3: [],
                    data4: [],
                    data5: [],
                },
                curCheckedList: [], //当前选中的数据
            };
        },
        created() {
            isthis = this;
        },
        mounted()
        {
            this.getPickAddress();
            this.getPickAddress_all();
            this.getList();
        },
        methods: {
            getPickAddress()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 0,
                        type: this.form.type    //type 1門店， 2是智能櫃
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data.filter(it=>it.company_id != 15);;
                    }
                });
            },

            getPickAddress_all()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 0,
                        // type: this.form.type    //type 1門店， 2是智能櫃
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress_all = res.data.data.filter(it=>it.company_id != 15);;
                    }
                });
            },

            getDateTime(datetime)
            {
                let date = new Date(datetime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hour = date.getHours();
                let minute = date.getMinutes();
                let second = date.getSeconds();
                let week = date.getDay();
                let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

                return {
                    date: `${this.formateNum_log(year)}-${this.formateNum_log(month)}-${this.formateNum_log(day)}`,
                    time: `${this.formateNum_log(hour)}:${this.formateNum_log(minute)}:${this.formateNum_log(second)}`,
                    week: weekList[week]
                };
            },

            formatDate(datetime)
            {
                if (!datetime) return '';
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },

            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },

            formateNum_log(num)
            {
                return num > 9 ? num : '0' + num;
            },

            getList(){
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.customer_allgoods,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        odd_numbers: form.odd_numbers,
                        recipient_phone: form.phone,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let class_temp = [];
                        let class_pay_type = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {

                            let integral_tw = 0;
                            if(resData[i].user != null)
                            {
                                for (let j = 0; j < resData[i].user.tw.length; j++)
                                {
                                    let integral_tw_count = Number(resData[i].user.tw[j].integral);
                                    integral_tw += integral_tw_count;
                                }
                            }

                            if(resData[i].pay_status == 0)
                            {
                                resData[i].pay_status = '未付款';
                            }
                            else
                            {
                                resData[i].pay_status = '已付款';
                            }

                            let order_online_overtime = '- - -';

                            if(resData[i].orderamount != null) {
                                if(resData[i].orderamount.order_online == 1){
                                    order_online_overtime = '積分';
                                }
                                if(resData[i].orderamount.order_online == 2){
                                    order_online_overtime = '中銀';
                                }
                                if(resData[i].orderamount.order_online == 3){
                                    order_online_overtime = '工銀';
                                }
                                if(resData[i].orderamount.order_online == 4){
                                    order_online_overtime = '微信';
                                }
                                if(resData[i].orderamount.order_online == 5){
                                    order_online_overtime = 'Mpay';
                                }
                                if(resData[i].orderamount.order_online == 6){
                                    order_online_overtime = '澳門通';
                                }
                                if(resData[i].orderamount.order_online == 7){
                                    order_online_overtime = '支付寶';
                                }
                                if(resData[i].orderamount.order_online == 8){
                                    order_online_overtime = '現金';
                                }
                                if(resData[i].orderamount.order_online == 9){
                                    order_online_overtime = '集金幣';
                                }
                            }

                            if(resData[i].orderamount == null) {
                                order_online_overtime = '- - -';
                            }

                            if(resData[i].orderamount == null && resData[i].pay_status == 1) {
                                order_online_overtime = '現金';
                            }

                            let goods_type;
                            if(resData[i].goods_type == 2){
                                goods_type = '是';
                            }
                            else{
                                goods_type = '否';
                            }                            

                            tempArr.push({
                                
                                id: resData[i].id,

                                admininfo: resData[i].admininfo == null ? '- - -' : resData[i].admininfo.realname,
                                
                                user_id: resData[i].user == null ? '- - -' : resData[i].user.user_id,
                                
                                recipient_contacts: resData[i].user == null ? resData[i].recipient_contacts :   resData[i].recipient_contacts + '【' + (resData[i].user.user_integral + integral_tw) + '】', //客戶名稱【積分】
                                
                                recipient_phone: resData[i].recipient_phone, //客戶電話 
                                
                                odd_numbers: resData[i].odd_numbers, //出貨單號
                                
                                pay_type: resData[i].pay_type == 0 ? '未在APP內付款' : '已在APP內付款', //APP付款状况

                                pay_status: resData[i].pay_status, //付款状况

                                goods_type: goods_type,

                                online_overtime: order_online_overtime,

                                sum: Number(resData[i].amount) + Number(resData[i].freight_collect) + Number(resData[i].surcharge_price) + Number(resData[i].outtimepays || 0) - Number(resData[i].store == null ? 0 : resData[i].store.activity) || 0, //合計費用
                                
                                receivingName: resData[i].store == null ? '- - -' : resData[i].store.ReceivingName, //取貨櫃點
                                
                                created_at: resData[i].created_at == null ? '- - -' : resData[i].created_at,

                                arrive: resData[i].arrive,

                                status: resData[i].status == null ? '- - -' : resData[i].status,
                            });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else
                    {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleEditStatusMuitplete(){
                if (!this.table.data.length)
                {
                    this.$Utils.showTipInfo('暂時沒有數據');
                    return;
                }

                this.curCheckedList = this.$refs.table.getSelection();
                if (!this.curCheckedList.length)
                {
                    this.$Utils.showTipInfo('請先勾選數據');
                    return;
                }

                let odd_numbers = this.curCheckedList.map((item, index) =>
                {
                    return item.odd_numbers;
                });

                this.isShowModalEditStatus = true;

                this.form_order_goods = odd_numbers;

                this.form_transfer.odd_numbers = String(odd_numbers);
            },
            
            handleModalSignClose_goods(){ //關閉快遞明細
                this.isShowModalSign_goods = false;
            },

            handleModalCloseEditStatus(){ //關閉修改狀態
                this.isShowModalEditStatus = false;

                this.form_order_goods = [];

                this.form_transfer = {
                    odd_numbers: '',
                    phone: '',
                    arrive: '',
                    type: "0",
                    code: '',
                    status: '',
                    cancel: "0",
                    remarks: '',
                };
            },

            handleModalCloseRefund(){ //關閉退款
                this.isShowModalRefund = false;
                this.form_transfer = {
                    odd_numbers: '',
                    phone: '',
                    arrive: '',
                    type: "0",
                    code: '',
                    status: '',
                    cancel: "0",
                    remarks: '',
                };
            },

            handleModalCloseTransfer(){ //關閉轉店
                this.isShowModalTransfer = false;
                this.form_transfer = {
                    odd_numbers: '',
                    phone: '',
                    arrive: '',
                    type: "0",
                    code: '',
                    status: '',
                    cancel: "0",
                    remarks: '',
                };
                this.form.type = "0";
            },

            handleModalCloseDelete(){ //關閉刪除
                this.isShowModalDelete = false;

                this.form_goods = [];
                this.form_transfer = {
                    odd_numbers: '',
                    phone: '',
                    arrive: '',
                    type: "0",
                    code: '',
                    status: '',
                    cancel: "0",
                    remarks: '',
                };
            },

            handleRefund(index){ //打開退款
                this.isShowModalRefund = true;
                let tableData = this.table.data;
                this.form_transfer.odd_numbers = tableData[index].odd_numbers;
                this.form_transfer.phone = tableData[index].recipient_phone;
                this.form_transfer.arrive = tableData[index].arrive;

                this.form_render.odd_numbers = tableData[index].odd_numbers;
                this.form_render.phone = tableData[index].recipient_phone;
                this.form_render.arrive = tableData[index].arrive;
            },

            handleTransfer(index){ //打開轉店
                this.isShowModalTransfer = true;
                let tableData = this.table.data;
                this.form_transfer.odd_numbers = tableData[index].odd_numbers;
                this.form_transfer.arrive = '0';
            },

            handleEditStatus(index){  //打開修改狀態
                this.isShowModalEditStatus = true;
                let tableData = this.table.data;
                this.form_transfer.odd_numbers = tableData[index].odd_numbers;
                this.form_order_goods.push(tableData[index].odd_numbers);
            },

            handleDelete(index){ //打開刪除
                this.isShowModalDelete = true;
                let tableData = this.table.data;
                this.form_goods.push(tableData[index].odd_numbers);
                this.form_transfer.odd_numbers = tableData[index].odd_numbers;
            },

            handleVerify(){  //驗證碼發送
                this.isSubmitingDelete = true;
                this.$Rq.requestAuth({
                    url: this.$Api.customer_verify,
                    method: 'post',
                }).then((res) => {
                    if (res.code == 0) {
                        this.isSubmitingDelete = false;
                        this.$Utils.showSuccess("驗證碼" + res.msg);
                    }else{
                        this.isSubmitingDelete = false;
                        this.$Utils.showTipInfo("驗證碼" + res.msg);
                    }
                }).catch((err) => {
                    this.isSubmitingDelete = false;
                    this.$Utils.showTipInfo("驗證碼" + res.msg);
                });
            },

            handleConfirmStatus(){ //確認修改狀態
                let form_transfer = this.form_transfer;
                if (form_transfer.status === '')
                {
                    this.$Utils.showTipInfo('請選擇節點狀態');
                    return;
                }

                this.isSubmitingEditStatus = true;

                this.$Rq.requestAuth({
                    url: this.$Api.customer_edit_order_status,
                    method: 'post',
                    data: {
                        orders: this.form_order_goods,
                        status: this.form_transfer.status,
                        pay_status: this.form_transfer.cancel,
                    }
                }).then((res) => {
                    if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.isSubmitingEditStatus = false;
                        this.handleModalCloseEditStatus();                    
                        this.getList();
                    } else {
                        this.isSubmitingEditStatus = false;
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmitingEditStatus = false;
                    this.$Utils.showTipInfo(res.msg); 
                });
            },

            handleConfirmDelete(){ //確認刪除
                let form_transfer = this.form_transfer;
                if(this.form_transfer.code === ''){
                    this.$Utils.showTipInfo('驗證碼不能為空');
                    return;
                }

                this.isSubmitingDelete = true;

                this.$Rq.requestAuth({
                    url: this.$Api.customer_soft_delete,
                    method: 'post',
                    data: {
                        order_numbers: this.form_goods,
                        code: this.form_transfer.code,
                    }
                }).then((res) => {
                    if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        this.isSubmitingDelete = false;
                        this.handleModalCloseDelete();                    
                        this.getList();
                    } else {
                        this.isSubmitingDelete = false;
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmitingDelete = false;
                    this.$Utils.showTipInfo(res.msg); 
                });
            },

            handleConfirmTransfer(){ //確認轉店
                let form_transfer = this.form_transfer;
                
                if (this.form.type === '' || this.form.type === 0 || this.form.type === "0")
                {
                    this.$Utils.showTipInfo('請選擇類型');
                    return;
                }
                if (form_transfer.arrive === '' || form_transfer.arrive === 0 || form_transfer.arrive === "0")
                {
                    this.$Utils.showTipInfo('請選擇轉店的門店');
                    return;
                }

                this.isSubmitingTransfer = true;
                this.$Rq.requestAuth({
                    url: this.$Api.settingTranferStore,
                    method: 'post',
                    data: {
                        orderNumber: form_transfer.odd_numbers,
                        arriveId: form_transfer.arrive,
                        remark: form_transfer.remarks,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                        this.isSubmitingTransfer = false;
                        this.handleModalCloseTransfer();                    
                        this.getList();
                    }
                    else
                    {
                        this.isSubmitingTransfer = false;
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmitingTransfer = false;
                    this.$Utils.showTipInfo(res.msg); 
                });
            },

            handleConfirmRefund(){ //確認退款
                let form_transfer = this.form_transfer;
                if (form_transfer.odd_numbers === '')
                {
                    this.$Utils.showTipInfo('快遞單號不能為空');
                    return;
                }
                if (form_transfer.arrive === '')
                {
                    this.$Utils.showTipInfo('店櫃選擇為空');
                    return;
                }
                if (form_transfer.phone === '')
                {
                    this.$Utils.showTipInfo('電話號碼為空');
                    return;
                }

                this.$Rq.requestAuth({
                    url: this.$Api.customer_edit_status,
                    method: 'post',
                    data: {
                        status: 2,
                        order: form_transfer.odd_numbers,
                        user_phone_update: Number(form_transfer.phone),
                        isRefund: Number(form_transfer.type),
                        arrive: Number(form_transfer.arrive),
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.isSubmitingRefund = false;
                        this.$Utils.showSuccess(res.msg);
                        this.handleModalCloseRefund();              
                        this.getList();
                    }
                    else
                    {
                        this.isSubmitingRefund = false;
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmitingRefund = false;
                    this.$Utils.showTipInfo(res.msg); 
                }); 
            },

            handleSearch(){
                this.pageIndex = 1;
                isthis.sums = 0;
                this.getList();
            },

            handlePageSizeChange(value){
                this.pageIndex = 1;
                isthis.sums = 0;
                this.getList();
            },

            handlePageInput(){
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.floor(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                isthis.sums = 0;
                this.pageInput = value;
            },

            handlePageEnter(){
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                isthis.sums = 0;
                this.getList();
            },

            handlePageChange(value){
                this.pageIndex = value;
                isthis.sums = 0;
                this.getList();
            },

            handleSelectionChange(){
                let sums = 0;
                this.curCheckedList = this.$refs.table.getSelection();
                this.curCheckedList.forEach((item => {
                    if(item.pay_type == '未在APP內付款'){
                        sums += item.sum
                    }else{
                        sums += item.outtimepay
                    }
                }))

                isthis.sums = Math.floor(sums)
            },

            handleViewOrder(index){
                this.isShowModalSign_goods = true;
                this.isSubmitingLog = true;
                let tableData = this.table.data;

                this.$Rq.requestAuth({
                    url: this.$Api.all_search,
                    method: 'get',
                    data: {
                        order: tableData[index].odd_numbers
                    }
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    let tempArr = [];
                    let tempArr1 = [];
                    let tempArr2 = [];
                    let tempArr3 = [];
                    let tempArr4 = [];
                    let tempArr5 = [];
                    let resData = res.data;

                    if (res.code == 0)
                    {
                        for (let i = 0; i < resData.data.length; i++)
                        {
                            tempArr.push({
                                order: resData.data[i].order,
                                username: resData.data[i].username,
                                phone: resData.data[i].phone,
                            });

                            tempArr1.push({
                                weight: resData.data[i].weight,
                                size_sum: resData.data[i].long + 'x' + resData.data[i].width + 'x' + resData.data[i].height,
                                store: resData.data[i].store == null ? '- - -' : resData.data[i].store.ReceivingName,
                            });

                            tempArr2.push({
                                sack_number: resData.data[i].sack_number,
                                detailed: resData.data[i].detailed == null ? '- - -' : resData.data[i].detailed.name,
                                abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
                            });

                            tempArr3.push({
                                shelves: resData.data[i].shelves == null ? '- - -' : resData.data[i].shelves.code,
                                status: resData.data[i].status,
                                created_time: resData.data[i].created_time,
                            });

                            tempArr4.push({
                                amount: resData.data[i].amount,
                                surcharge_price: resData.data[i].surcharge_price,
                                freight_collect: resData.data[i].freight_collect,
                            });

                            tempArr5.push({
                                outTime_price: resData.data[i].outTime_price,
                                total_price: Number(resData.data[i].surcharge_price) + Number(resData.data[i].outTime_price) + Number(resData.data[i].freight_collect) + Number(resData.data[i].amount),
                            });
                        }
                        this.table1.data = tempArr;
                        this.table1.data1 = tempArr1;
                        this.table1.data2 = tempArr2;
                        this.table1.data3 = tempArr3;
                        this.table1.data4 = tempArr4;
                        this.table1.data5 = tempArr5;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            
                this.isSubmitingLog = true;
                this.$Rq.requestAuth({
                    url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
                    method: 'get',
                    data: {}
                }).then((res) =>
                {
                    this.isSubmitingLog = false;
                    if (Number(res.code) == 0)
                    {
                        let resData = res.data;
                        let tempArr = [];
                        let userinfo;

                        for (let j = 0; j < resData.length; j++)
                        {
                            let datetime = this.getDateTime(resData[j].created_at);
                            
                            if(resData[j].userinfos == null){
                                if(resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)){
                                    userinfo = '用戶線上支付';
                                }else{
                                    if(resData[i].admin_name != null){
                                        userinfo = resData[i].admin_name;
                                    }else{
                                        userinfo = '智能櫃派送員';
                                    }
                                }
                            }else{
                                userinfo = resData[j].userinfos.username;
                            }

                            tempArr.push({
                                userinfos: userinfo,
                                id: resData[j].id,
                                date: datetime.date,
                                week: datetime.week,
                                time: datetime.time,
                                describe: resData[j].remarks
                            });
                        }

                        this.detail = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isSubmitingLog = false;
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import 'allgoodsigntodo.scss';
</style>
<style>
    .ivu-table td.demo-table-info-column{
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table td.demo-table-info-cell-name {
        background-color: #D6E7FF;
        color: #515A6E;
    }
    .ivu-table td.demo-table-info-cell-name-sum {
        background-color: #FFEBDE;
        color: #000;
    }
    .ivu-table .demo-table-error-row {
        background-color: #fcffd6;
        color: #515A6E;
    }
    .ivu-table .demo-table-info-row {
        background-color: #FFEBDE;
        color: #515A6E;
    }
    .ivu-table .demo-table-app-row {
        background-color: #e8ffd6;
        color: #515A6E;
    }
</style>